import { rgba, transparentize } from 'polished'
import styled, { StyledProps } from 'styled-components'

interface RootProps {
  invalid: boolean
  selected: boolean
  disabled?: boolean
}

const squareRoot2 = 1.414213
const borderSize = '1px'
const borderSizeFocused = '2px'
const horizontalPaddingPixels = 15
const caretPixels = 12
const caretMarginTop = `${caretPixels * (-1 / squareRoot2)}px`
const horizontalPadding = `${horizontalPaddingPixels}px`
const caretSize = `${caretPixels}px`

const labelColor = (props: StyledProps<RootProps>): string => rgba(props.theme.colors.text, 0.5)

const brandColor = (props: StyledProps<RootProps>): string =>
  props.invalid
    ? props.theme.colors.invalid
    : props.disabled
      ? transparentize(0.3, props.theme.colors.brandA500)
      : props.theme.colors.brandA500

const Root = styled.span<RootProps>`
  /* prettier-ignore */
  box-shadow: inset 0 0 0 ${borderSize} ${(props) =>
    props.invalid ? props.theme.colors.invalid : props.theme.colors.border};

  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  select {
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  }

  /* The Caret */
  ::before {
    content: '';
    display: block;
    top: 50%;
    right: ${horizontalPadding};
    position: absolute;
    height: ${caretSize};
    width: ${caretSize};
    margin-top: ${caretMarginTop};
    border: solid ${borderSize} transparent;
    border-bottom-color: ${(props) => labelColor(props)};
    border-right-color: ${(props) => labelColor(props)};
    transform: rotate(45deg);
    z-index: 1;
  }

  :focus-within::before {
    border: solid ${borderSizeFocused} transparent;
    border-bottom-color: ${(props) => props.theme.colors.brandA500};
    border-right-color: ${(props) => props.theme.colors.brandA500};
  }

  &:focus-within {
    /* prettier-ignore */
    box-shadow: inset 0 0 0 ${borderSizeFocused} ${brandColor};
  }

  .floatingLabelSelectLabel {
    color: ${(props) => (props.selected ? brandColor(props) : labelColor(props))};
    padding-left: 8px;
  }
`
export default Root
